export const CHROME = 'chrome';
export const CHROME_ON_IOS = 'crios';
export const FIREFOX = 'firefox';
export const EDGE = 'edge';
export const SAFARI = 'safari';
export const SAFARI_ON_IOS = 'ios';


// WEBPACK FOOTER //
// ./src/commons/DetectionConstants.tsx